/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-this-alias */
import React, { Component } from 'react';
import styled from '@emotion/styled';
import { colors, dimensions } from '@styles';
import { ConfiguratorActions } from '@store/actions';
import { FormDeliveryData, FormData, FormValidation } from '@store/content/types';
import { ConfiguratorSettings } from '@content/types/configuratorSettings';
import { validateInputs } from '@components/configurator/contactForm/ContactFormInputsData';
import FormRadioButton from '@components/common/FormRadioButton';
import FormInput from '@components/common/FormInput';
import { Row } from '@components/configurator/contactForm/ContactFormPanel';

const DeliveryTitle = styled.h5`
  font-size: ${dimensions.fontSize.large}px;
  font-weight: 300;
  margin-bottom: 24px;
`;

const DeliveryWrapper = styled.div`
  margin: 25px 0;
`;

const DeliveryAddressWrapper = styled.div`
  p {
    font-size: ${dimensions.fontSize.large}px;
    font-weight: 300;
    margin-bottom: 24px;

    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: ${colors.gray};
      margin: 18px 0 24px;
    }
  }
`;

interface ContactFormDeliveryProps {
  configuratorActions: typeof ConfiguratorActions;
  onChangeInput: Function;
  onBlurInput: Function;
  deliveryData: FormDeliveryData;
  pageSettings: ConfiguratorSettings;
  formData: FormData;
  formValidation: FormValidation;
}

class ContactFormDelivery extends Component<ContactFormDeliveryProps> {
  state = {
    radioValue: 'sameAddress',
  };

  componentDidMount() {
    this.setState({
      radioValue:
        this.props.deliveryData && this.props.deliveryData.deliveryType
          ? this.props.deliveryData.deliveryType
          : 'sameAddress',
    });
  }

  onRadioChange = (value: string) => {
    this.setState({ radioValue: value }, () => {
      this.props.configuratorActions.setDelivertType({
        deliveryType: value,
      });
    });
  };

  render() {
    const pPole = this.props.pageSettings.field_proste_pola;
    const inputsAddress2 = [
      [
        { name: 'address2Street', type: 'text', labelText: pPole ? pPole[56] : '', maxlength: 40 },
        {
          name: 'address2HouseNumber',
          type: 'text',
          labelText: pPole ? pPole[57] : '',
          maxlength: 10,
        },
        {
          name: 'address2ApartmentNumber',
          type: 'text',
          labelText: pPole ? pPole[58] : '',
          maxlength: 10,
        },
      ],
      [
        { name: 'address2PostalCode', type: 'text', labelText: pPole ? pPole[59] : '' },
        { name: 'address2City', type: 'text', labelText: pPole ? pPole[60] : '', maxlength: 40 },
      ],
    ];

    return (
      <DeliveryWrapper>
        <DeliveryTitle>{pPole && pPole[113]}</DeliveryTitle>

        <FormRadioButton
          name="delivery-selection"
          list={[
            {
              value: 'sameAddress',
              label: pPole ? pPole[114] : '',
              price: pPole ? pPole[115] : '',
            },
            {
              value: 'newAddress',
              label: pPole ? pPole[116] : '',
              price: pPole ? pPole[117] : '',
            },
          ]}
          handleRadioChange={this.onRadioChange}
          radioValue={this.state.radioValue}
        />

        {this.state.radioValue === 'newAddress' ? (
          <DeliveryAddressWrapper>
            <p>{pPole && pPole[62]}</p>

            {inputsAddress2.map((row, index) => (
              <Row key={index} className={index === 0 ? 'three-children' : 'two-children'}>
                {row.map(input => (
                  <FormInput
                    key={input.name}
                    name={input.name}
                    type={input.type}
                    labelText={input.labelText}
                    maxlength={input.maxlength}
                    value={this.props.formData[input.name]}
                    onChangeInput={this.props.onChangeInput}
                    onBlurInput={this.props.onBlurInput}
                    validation={this.props.formValidation[input.name]}
                    validateSchema={validateInputs[input.name]}
                    configuratorActions={this.props.configuratorActions}
                    textsList={pPole ? pPole : []}
                  />
                ))}
              </Row>
            ))}
          </DeliveryAddressWrapper>
        ) : null}
      </DeliveryWrapper>
    );
  }
}

export default ContactFormDelivery;
